export default "__VITE_ASSET__YxPcl1N7__"